<template>
  <text-custom-modal
    title="Keywords"
    custom-style="width: 570px;"
    content-style="padding: 20px 40px 35px 40px;"
    :keywords="keywords"
    @onSave="onAddKeyword"
    @onCancel="closeKeywordsModal"
  >
    <span class="description">Messages with the following keywords will route to {{ target }}</span>
    <div class="select-container">
      <form>
        <input
          v-model="newKeyword"
          type="text"
          placeholder="+ Add keyword"
          class="text-word"
          @keypress.prevent.enter="onAddKeyword"
        />
      </form>
      <div>
        <span v-for="(keyword, index) in keywords" :key="keyword">
          <keyword-item :keyword="keyword" @removeKeyword="removeKeyword(index)" />
        </span>
      </div>
    </div>
  </text-custom-modal>
</template>

<script>
import TextCustomModal from './TextCustomModal';
import KeywordItem from './KeywordItem';

export default {
  name: 'KeywordsModal',
  components: {
    KeywordItem,
    TextCustomModal
  },
  props: {
    route: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    newKeyword: '',
    keywords: []
  }),
  computed: {
    target() {

                                        
            if(!this.route || !this.route.target)
             {
              return "";
             }
   
   
      return  this.route.target.name ? this.route.target.name :  (this.route.target.fullName ? this.route.target.fullName : "");
    },
    name ()
    {
     
                      if(!this.keywords)
                                  {
                                    return "Add"
                                  }
  
      return this.keywords.length > 0 ? "Save" : "Add"      
    }
  },
  mounted() {

                  if(!this.route || !this.route.keywords)
                  {
                    console.log("s")
                  }
                  else
                   {
                       if (this.route.keywords.length > 0) {
      this.keywords = this.route.keywords;
    }
 

                   }
  
  
  },
  methods: {
    /**
     * Adding keywords
     */
    onAddKeyword() {
      this.newKeyword = this.newKeyword.trim().toLowerCase();
      const isEntered = this.keywords.some((word) => word === this.newKeyword);
      if (isEntered) {
        return (this.newKeyword = '');
      }
   
      // get keywords from the input
      const words = this.newKeyword.split(',');
      const filtered = words.reduce((arr, word) => {
        const formattedWord = word.trim().toLowerCase();
        if (formattedWord && !arr.includes(formattedWord)) {
          arr.push(formattedWord);
        }
        return arr;
      }, []);

      // make sure that only new keywords are added
      const newKeywords = filtered.filter((word) => !this.keywords.includes(word));

      // use Set to leave only the unique values
      this.keywords = [...this.keywords, ...[...new Set(newKeywords)]];
      this.newKeyword = '';
                                
      this.$emit('onSave', {
        ...this.route,
        keywords: this.keywords
      });

return this.$emit('onCancel');

      
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
      this.$emit('onSave', {
        ...this.route,
        keywords: this.keywords
      });
    },
    closeKeywordsModal() {
      return this.$emit('onCancel');
    }
  }
};
</script>

<style scoped lang="scss">
.description {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: $colorText;
  z-index: 100000;
}
.text-word {
  width: 510px;
  height: 40px;
  left: 465px;
  top: 403px;
  background: #f4f5f7;
  border-radius: 3px;
  margin-bottom: 10px;
  font-size: 14px;
  border: none;
  padding: 0 15px;
}
</style>
